import FeatureGates from '@atlaskit/feature-gate-js-client';

import {
	BLANK_PAGE_QUICK_ACTIONS_EXPERIMENT,
	BLANK_PAGE_QUICK_ACTIONS_MULTI_VARIANT_COHORTS,
	BLANK_PAGE_QUICK_ACTIONS_MILESTONE_3_EXPERIMENT,
	BLANK_PAGE_QUICK_ACTIONS_MILESTONE_2_EXPERIMENT,
	BLANK_PAGE_QUICK_ACTIONS_SINGLE_VARIANT_COHORTS,
	COHORT,
	SMART_BUTTON_BLANK_PAGE_QUICK_ACTIONS_EXPERIMENT,
	SMART_BUTTON_BLANK_PAGE_QUICK_ACTIONS_COHORTS,
} from './bpqaConst';

/*
 * Eligiblity hook for milestone 1 experiment for BPQA v2
 */
export const getBlankPageQuickActionsExperimentEnabled = ({
	shouldFireExperimentExposure = false,
}: {
	shouldFireExperimentExposure: boolean;
}) => {
	//  Returns the cohort of the tenant: not-enrolled, control, or test
	const cohort = FeatureGates.getExperimentValue<BLANK_PAGE_QUICK_ACTIONS_MULTI_VARIANT_COHORTS>(
		BLANK_PAGE_QUICK_ACTIONS_EXPERIMENT,
		COHORT,
		BLANK_PAGE_QUICK_ACTIONS_MULTI_VARIANT_COHORTS.NOT_ENROLLED,
		{ fireExperimentExposure: shouldFireExperimentExposure },
	);

	// Returns if the user should see BPQA experiment, do NOT use for exposure events
	const isBPQAExperimentEnabled =
		cohort === BLANK_PAGE_QUICK_ACTIONS_MULTI_VARIANT_COHORTS.VARIANT1 ||
		cohort === BLANK_PAGE_QUICK_ACTIONS_MULTI_VARIANT_COHORTS.VARIANT2;

	return {
		cohort,
		isBPQAExperimentEnabled,
	};
};

/*
 * Eligiblity hook for milestone 2 experiment for BPQA v2
 */
export const getBPQAMilestone2ExperimentEnabled = ({
	shouldFireExperimentExposure = false,
}: {
	shouldFireExperimentExposure: boolean;
}) => {
	//  Returns the cohort of the tenant: not-enrolled, control, or test
	const milestone2Cohort =
		FeatureGates.getExperimentValue<BLANK_PAGE_QUICK_ACTIONS_SINGLE_VARIANT_COHORTS>(
			BLANK_PAGE_QUICK_ACTIONS_MILESTONE_2_EXPERIMENT,
			COHORT,
			BLANK_PAGE_QUICK_ACTIONS_SINGLE_VARIANT_COHORTS.NOT_ENROLLED,
			{ fireExperimentExposure: shouldFireExperimentExposure },
		);

	// Returns if the user should see BPQA experiment milestone 2, do NOT use for exposure events
	const isBPQAMilestone2ExperimentEnabled =
		milestone2Cohort === BLANK_PAGE_QUICK_ACTIONS_SINGLE_VARIANT_COHORTS.TEST;

	return {
		milestone2Cohort,
		isBPQAMilestone2ExperimentEnabled,
	};
};

/*
 * Eligiblity hook for milestone 3 experiment for BPQA v2
 */
export const getBPQAMilestone3ExperimentEnabled = ({
	shouldFireExperimentExposure = false,
}: {
	shouldFireExperimentExposure: boolean;
}) => {
	//  Returns the cohort of the tenant: not-enrolled, control, or test
	const milestone3Cohort =
		FeatureGates.getExperimentValue<BLANK_PAGE_QUICK_ACTIONS_SINGLE_VARIANT_COHORTS>(
			BLANK_PAGE_QUICK_ACTIONS_MILESTONE_3_EXPERIMENT,
			COHORT,
			BLANK_PAGE_QUICK_ACTIONS_SINGLE_VARIANT_COHORTS.NOT_ENROLLED,
			{ fireExperimentExposure: shouldFireExperimentExposure },
		);

	// Returns if the user should see BPQA experiment milestone 3, do NOT use for exposure events
	const isBPQAMilestone3ExperimentEnabled =
		milestone3Cohort === BLANK_PAGE_QUICK_ACTIONS_SINGLE_VARIANT_COHORTS.TEST;

	return {
		milestone3Cohort,
		isBPQAMilestone3ExperimentEnabled,
	};
};

export const getSmartButtonBlankPageQuickActionsExperimentEnabled = () => {
	const cohort = FeatureGates.getExperimentValue<SMART_BUTTON_BLANK_PAGE_QUICK_ACTIONS_COHORTS>(
		SMART_BUTTON_BLANK_PAGE_QUICK_ACTIONS_EXPERIMENT,
		COHORT,
		SMART_BUTTON_BLANK_PAGE_QUICK_ACTIONS_COHORTS.CONTROL,
	);

	return cohort === SMART_BUTTON_BLANK_PAGE_QUICK_ACTIONS_COHORTS.SMART_BUTTON;
};
